import { render, staticRenderFns } from "./__detail_storehouse.vue?vue&type=template&id=6cd3ee6c&scoped=true&"
import script from "./__detail_storehouse.vue?vue&type=script&lang=js&"
export * from "./__detail_storehouse.vue?vue&type=script&lang=js&"
import style0 from "./__detail_storehouse.vue?vue&type=style&index=0&id=6cd3ee6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3ee6c",
  null
  
)

export default component.exports